module.exports = __webpack_public_path__ + "static/media/draft.29819378.svg";